import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    serverToken: '',
    spinning: false,
  },
  getters: {
  },
  mutations: {
    setServerToken(state, token) {
      state.serverToken = token;
    },
    setSpinning(state, value) {
      state.spinning = value;
    },
  },
  actions: {
  },
  modules: {
  },
});
